import React from "react";
import { Link } from "react-router-dom";
import "../styles/about-wrap.scss";

const AboutOne = () => {
  return (
    <div className="about-area-1 position-relative about-kiubunifu">
      <div className="container">
        {/* Center the content like the Values section */}
        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div className="about-content-wrap text-center">
              <div className="title-area text-center me-xl-4 ms-xl-4">
                {/* <span className="sub-title">
                  <img src="assets/img/icon/title_left.svg" alt="shape" />
                  About Kiubunifu
                </span> */}
                <h2 className="sec-title style2">Who We Are</h2>
                <p className="sec-text mb-35">
                  Kiubunifu is a platform-powered company at the intersection of people, skills, technology, and work.
                </p>
              </div>

              {/* Vision + Mission side by side */}
              <div className="row g-4 justify-content-center">
                {/* Vision */}
                <div className="col-md-6">
                  <div className="achive-about text-start">
                    <div className="achive-about_content">
                      <div className="achive-about_icon">
                        {/* <i className="fas fa-check" /> */}
                      </div>
                      <div className="media-body">
                        <h3 className="box-title">Our Purpose</h3>
                        <p className="achive-about_text">
                          We exist to enable professionals to collaborate, learn and grow, build networks, and enhance their economic well-being.

                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Mission */}
                <div className="col-md-6">
                  <div className="achive-about text-start">
                    <div className="achive-about_content">
                      <div className="achive-about_icon">
                        {/* <i className="fas fa-check" /> */}
                      </div>
                      <div className="media-body">
                        <h3 className="box-title">Our Mission</h3>
                        <p className="achive-about_text">
                          To build an ecosystem of professionals and enable them to globalise their reach.

                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="btn-wrap mt-20">
                {/* <Link to="/about" className="global-btn mt-xl-0 mt-20">
                  Read More <i className="fas fa-arrow-right ms-2" />
                </Link> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutOne;
